export default __webpack_public_path__ + "static/N0113-9e737e1a594db9984be2cec35bf15eaf.png";